export default "__VITE_ASSET__BFGej56F__"